import { useContext } from "react";
import { AuthContext } from "./AuthProvider";

export const check = (roles, requestedPermission) => {
  
  for (let i = 0; i < requestedPermission.length; i++) {
    for (let j = 0; j < roles.length; j++) {
      if (roles[j].permissions.some((p) => p.permissionName == requestedPermission[i])) return true;
    }
  }
  return false;
};

const Can = (props) => {
    const { roles } = useContext(AuthContext);
  // allow access if no permissions were provided
  if (!props.perform) return props.yes();

  let permissions = Array.isArray(props.perform) ? props.perform : [props.perform];
  return check(roles, permissions) ? props.yes() : props.no();
};

Can.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default Can;
